<du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.JSONATA]}">
    <detail-header>
        @if (logoUrl && logoUrl.length > 0) {
            <img
                    [ngSrc]="logoUrl"
                    alt="JSONata logo"
                    width="64" height="64" priority>
        }
        <div>
            <h1 class="detail-header-title">
                {{ selectedJsonataExpression?.identification ?? 'JSONata Expressions' }}
            </h1>
            @if (selectedJsonataExpression?.id != null) {
                <p class="detail-header-subtitle">{{ "#" + selectedJsonataExpression?.id }}</p>
            }
            <a href="https://docs.jsonata.org/overview.html"
               target="_blank"
               class="detail-header-subtitle">
                {{ 'jsonata.documentation' | translate }}
            </a>
        </div>
    </detail-header>
    <detail-header-action>
        {{ "jsonata.wordWrap" | translate }}
        <p-toggleswitch [(ngModel)]="wordWrapEnabled" (ngModelChange)="onWordWrapChange()">
        </p-toggleswitch>
    </detail-header-action>
    <detail-body>
        <p-card class="jsonata-card">
                <div class="exerciser-container">
                    <div class="editor-panel" #editorPanel>
                        <div class="editor-container">
                            <div class="editor-header">
                                <i class="pi pi-code"></i>
                                <span>{{ 'jsonata.jsonInput' | translate }}</span>
                                <div class="setting-selector">
                                    <p-select appendTo="body" [(ngModel)]="selectedApplicationSetting"
                                                  (ngModelChange)="onApplicationSettingChange($event)"
                                                  [options]="applicationSettingOptions" optionLabel="label" optionValue="data" [placeholder]="'jsonata.application' | translate"/>
                                </div>
                                <div class="id-selector">
                                    <p-select appendTo="body" [(ngModel)]="selectedApplicationSettingId"
                                                  (ngModelChange)="onIdChange($event)"
                                                  [options]="applicationSettingIdOptions" optionLabel="label" optionValue="data" placeholder="ID"/>
                                </div>
                            </div>
                            <div class="editor">
                                <ngx-monaco-editor [options]="jsonEditorOptions" [(ngModel)]="jsonData"
                                                   (ngModelChange)="evaluateJsonata()"></ngx-monaco-editor>
                            </div>
                        </div>
                    </div>
                    <div class="resize-handle" #resizeHandle></div>
                    <div class="editor-panel" #editorPanel>
                        <div class="editor-container">
                            @if (!isComparisonActive) {
                                <div class="editor-header">
                                    <i class="pi pi-code"></i>
                                    <span>JSONata Expression</span>
                                    <div class="setting-selector">
                                        <p-select appendTo="body" [(ngModel)]="selectedJsonataExpression"
                                                      (ngModelChange)="onJsonataChange($event)"
                                                      [options]="jsonataSettingOptions" optionLabel="label" optionValue="data" placeholder="JSONata"/>
                                    </div>
                                    <div class="id-selector">
                                        <p-select appendTo="body" [(ngModel)]="selectedRevision"
                                                      (ngModelChange)="onRevisionSelected($event)"
                                                      [options]="revisionOptions" optionLabel="label" optionValue="data" [placeholder]="'appSettings.compareRev' | translate"/>
                                    </div>
                                </div>
                                <div class="editor">
                                    <ngx-monaco-editor [options]="jsonataEditorOptions" [(ngModel)]="jsonataData"
                                                       (ngModelChange)="evaluateJsonata()"></ngx-monaco-editor>
                                </div>
                            } @else {
                                <div class="editor-header">
                                    <i class="pi pi-code"></i>
                                    <div class="version-label">
                                        {{ selectedJsonataExpression?.identification }}
                                        #{{ selectedJsonataExpression?.id }}
                                    </div>
                                    <div class="version-label form">
                                        <div class="id-selector">
                                            <p-select appendTo="body" [(ngModel)]="selectedRevision"
                                                          (ngModelChange)="onRevisionSelected($event)"
                                                          [options]="revisionOptionsStop" optionLabel="label" optionValue="data" [placeholder]="'appSettings.compareRev' | translate"/>
                                        </div>
                                    </div>
                                    <p-button [rounded]="true" [text]="true" severity="secondary" (click)="stopComparing()"><i class="pi pi-times"></i></p-button>
                                </div>
                                <div class="editor">
                                    <ngx-monaco-diff-editor
                                            [options]="options"
                                            [originalModel]="originalModel"
                                            [modifiedModel]="modifiedModel">
                                    </ngx-monaco-diff-editor>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="resize-handle" #resizeHandle></div>
                    <div class="editor-panel" #editorPanel>
                        <div class="editor-container">
                            <div class="editor-header">
                                <i class="pi pi-code"></i>
                                <span>{{ 'jsonata.output' | translate }}</span>
                            </div>
                            <div class="editor">
                                <ngx-monaco-editor [options]="outputEditorOptions"
                                                   [(ngModel)]="outputData"></ngx-monaco-editor>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="exerciser-actions">
                    @if (isComparisonActive) {
                        <p-button severity="secondary" (click)="replaceOriginalCode()">
                            <i class="pi pi-sync"></i>
                            {{ 'button.replace' | translate | uppercase }}
                        </p-button>
                    }
                    <p-button (click)="saveJsonata()">
                        <i class="pi pi-save"></i>
                        {{ 'button.save' | translate | uppercase }}
                    </p-button>
                </div>
        </p-card>
    </detail-body>
</du-config-detail>
